import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { ComputerBackupRestoreStatus } from 'mbs-ui-shared@models/Computer';
import { of } from 'rxjs';
import { SmartSearchBaseTemplateComponent } from './smart-search-base-template.component';

@Component({
  selector: 'mbs-smart-search-plan-status-template',
  templateUrl: './smart-search-base-template.component.html',
  imports: [CommonModule]
})
export class SmartSearchPlanStatusTemplateComponent extends SmartSearchBaseTemplateComponent {
  i18nPipe: I18NextPipe;

  constructor() {
    const i18nPipe = inject(I18NextPipe);

    super();

    this.i18nPipe = i18nPipe;
  }
  public tag = 'Plan status';
  public filterPropertyName = 'displayValue';
  public items = () =>
    of(
      Object.values(ComputerBackupRestoreStatus).map((value) => ({
        value,
        searchText: value,
        displayValue: this.i18nPipe.transform(`shared:computers.planStates.${value}`),
        translation: `shared:computers.planStates.${value}`
      }))
    );
}
